import script from "./boardListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./boardListPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__